import React,{useEffect} from 'react';
import HeaderSec from '../components/HeaderSec';
import Footer from '../components/Footer';
import PaymentMethods from '../components/PaymentMethods';
import Accordians from '../components/Accordians';
import CookiesPopup from '../components/CookiesPopup';
import WhatsappChat from '../components/WhatsappChat';
import ScrollTop from '../components/ScrollTop';
import ContactIcon from '../components/ContactIcon';
import Title from "../components/Title";
import FaqBanner from '../components/faq/FaqBanner';
import ContactUs from '../components/ContactUs';

const Faq = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
      }, []);
        return(
            <>
            <Title title="FAQ | CAD AND RENDER" />
            <HeaderSec />

            <FaqBanner />

            <div className='cadAboutContent'>
                <div className='container'>
                    <p>At CAD and RENDER, we specialize in providing high-quality jewelry 3D CAD Designing and Realistic Rendering services to jewelry manufacturers, wholesalers and retailers. With years of experience in the industry, we have become experts in our craft and are dedicated to providing exceptional service to our clients.</p>
                </div>
            </div>

            <ContactIcon />
            <WhatsappChat />
            <ScrollTop />
            <CookiesPopup />

            <div className='cadFaqAcc'>
                <div className='container'>
                    <Accordians />
                </div>
            </div>
            
            <ContactUs />

            <PaymentMethods />

            <Footer />
            </>
        )
}


export default Faq;